/**
 * Converts a data URL string (e.g. "data:application/pdf;base64,JVBERi0x...")
 * to a binary Blob.
 */
export const dataUrlToBlob = (dataUrl: string): Blob => {
  const [header, data] = dataUrl.split(',');
  const mimeType = header.replace('data:', '').replace(';base64', '');
  const byteCharacters = atob(data);
  const byteNumbers = new Uint8Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.codePointAt(i) ?? 0;
  }
  return new Blob([byteNumbers], { type: mimeType });
};

/**
 * Triggers a browser file download for the given Blob.
 */
export const triggerBlobDownload = (blob: Blob, fileName: string): void => {
  const url = globalThis.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || 'downloaded-file';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => globalThis.URL.revokeObjectURL(url), 1000);
};
